module.exports = __webpack_public_path__ + "static/media/stopwatch.9ce632eb.svg";